var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoringDbLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#EDEDED",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4456_8800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.75 16.375C10.75 16.6097 11.0958 17.0185 11.8975 17.4198C12.9355 17.9387 14.4078 18.25 16 18.25C17.5922 18.25 19.0645 17.9387 20.1025 17.4198C20.9042 17.0185 21.25 16.6097 21.25 16.375V14.7468C20.0125 15.5118 18.1202 16 16 16C13.8798 16 11.9875 15.511 10.75 14.7468V16.375ZM21.25 18.4967C20.0125 19.2618 18.1202 19.75 16 19.75C13.8798 19.75 11.9875 19.261 10.75 18.4967V20.125C10.75 20.3597 11.0958 20.7685 11.8975 21.1698C12.9355 21.6887 14.4078 22 16 22C17.5922 22 19.0645 21.6887 20.1025 21.1698C20.9042 20.7685 21.25 20.3597 21.25 20.125V18.4967ZM9.25 20.125V12.625C9.25 10.7613 12.2725 9.25 16 9.25C19.7275 9.25 22.75 10.7613 22.75 12.625V20.125C22.75 21.9887 19.7275 23.5 16 23.5C12.2725 23.5 9.25 21.9887 9.25 20.125ZM16 14.5C17.5922 14.5 19.0645 14.1887 20.1025 13.6697C20.9042 13.2685 21.25 12.8598 21.25 12.625C21.25 12.3902 20.9042 11.9815 20.1025 11.5802C19.0645 11.0612 17.5922 10.75 16 10.75C14.4078 10.75 12.9355 11.0612 11.8975 11.5802C11.0958 11.9815 10.75 12.3902 10.75 12.625C10.75 12.8598 11.0958 13.2685 11.8975 13.6697C12.9355 14.1887 14.4078 14.5 16 14.5Z",
    fill: "#EDEDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4456_8800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoringDbLogo);
export default __webpack_public_path__ + "static/media/storingDBLogo.fa941f7f50a48ed3b16305aadc5baee0.svg";
export { ForwardRef as ReactComponent };